import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.c/KktL',
    defaultMessage: 'Resources',
  },
});
